import * as borogove from "borogove";
import { useNavigate, useOutletContext } from "react-router";
import { useQueryState } from "nuqs";
import { useState, useEffect } from "react";
import {
	Avatar,
	ChatContainer,
	ConversationHeader,
	Message,
	MessageList,
} from "@chatscope/chat-ui-kit-react";
import { useDebounce } from "../hooks/use-debounce";

import { AvatarWithPlaceholder } from "./AvatarWithPlaceholder";
import { MessageBubble } from "./MessageBubble";
import { MessageMenuInSearch } from "./MessageMenuInSearch";
import { Virtuoso } from "react-virtuoso";
import { useEffectEvent, membersForMessages } from "../util";

export const SearchMessages = () => {
	const navigate = useNavigate();
	const { active, persistence, client } = useOutletContext<{
		active: boolean;
		persistence: borogove.Persistence;
		client: borogove.Client;
	}>();
	const [searchQ] = useQueryState("q");

	const [searchMessageResults, setSearchMessageResults] = useState<{
		messages: borogove.ChatMessage[];
		members: Map<string, borogove.Member>;
	}>({ messages: [], members: new Map() });
	const debouncedSearch = useDebounce(searchQ, 300);
	const doSearch = useEffectEvent(async () => {
		if (!searchQ) return;

		// TODO: what about sqlite persistence?
		const messages = await (
			persistence as Awaited<ReturnType<typeof borogove.persistence.IDB>>
		).searchMessages(client.accountId(), null, searchQ);

		const members = await membersForMessages(
			messages,
			(ids) => persistence.getMemberDetails(client.accountId(), null, ids),
			(id) => !searchMessageResults.members.has(id),
		);

		setSearchMessageResults({
			messages,
			members: new Map([...searchMessageResults.members, ...members]),
		});
	});
	useEffect(() => {
		doSearch();
	}, [debouncedSearch]);

	return (
		<ChatContainer className={active ? "active" : undefined}>
			<ConversationHeader>
				<ConversationHeader.Back onClick={() => navigate("../")} />
				<ConversationHeader.Content userName="Search Results" />
			</ConversationHeader>
			<div as={MessageList} className="cs-message-list">
				<Virtuoso
					key={searchQ}
					followOutput={true}
					alignToBottom={true}
					data={searchMessageResults.messages}
					itemContent={(index, m) => {
						const chat = client.getChat(m.chatId());
						if (!chat) return <div />;

						const sender = searchMessageResults.members.get(m.senderId)!;
						return (
							<MessageBubble
								key={m.serverId || m.localId}
								chat={chat}
								position={"single"}
								client={client}
								members={searchMessageResults.members}
								setSelectedThread={() => {}}
								m={m}
							>
								<AvatarWithPlaceholder
									as={Avatar}
									photoUri={sender?.photoUri}
									placeholderUri={sender?.placeholderUri}
									displayName={sender?.displayName}
								/>

								<MessageMenuInSearch as={Message.Header} m={m} />
							</MessageBubble>
						);
					}}
				/>
			</div>
		</ChatContainer>
	);
};
